import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'

const options = formFieldCommonOptions('FormTextfield', {
    validatorFunction(input) {
        return !!(input.length > 1)
    }
})

export default options
